var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.editor},[_c('Head'),_c('TabGroup'),_c('div',{class:_vm.$style.editor__content},[_c('IntroInCode'),_c('AboutMe'),_c('PlaySnake')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }